import { useTheme } from '../contexts/ThemeContext';

function ModeSelector({ currentMode, onModeChange }) {
    const { theme } = useTheme();
    const modes = [
        { id: 'in-person', label: 'In-Person' },
        { id: 'virtual', label: 'Virtual' },
        { id: 'single', label: 'Single' }
    ];

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '30px',
            flexShrink: 0
        }}>
            <div style={{
                display: 'flex',
                backgroundColor: theme.bgDark,
                borderRadius: '12px',
                padding: '4px',
                border: `2px solid ${theme.secondary}`,
                gap: '4px'
            }}>
                {modes.map(mode => (
                    <button
                        key={mode.id}
                        onClick={() => onModeChange(mode.id)}
                        style={{
                            padding: '10px 20px',
                            fontSize: '0.95rem',
                            backgroundColor: currentMode === mode.id ? theme.accent : 'transparent',
                            color: currentMode === mode.id ? theme.textPrimary : theme.textSecondary,
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            fontFamily: 'inherit',
                            fontWeight: currentMode === mode.id ? 'bold' : 'normal',
                            minWidth: '100px',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {mode.label}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default ModeSelector;
